import fr from './fr.json'
import en from './en.json'

export default {
  fr: fr,
  en: en,
}
